import { DateFilter } from '@gtpl/shared-models/common-models';
import { CommonResponse } from '@gtpl/shared-models/masters';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { MetalDetectionDto } from './dto/metal-detection.dto';
import { MetalDetectionService } from './metal-detection.service';
@ApiTags('Metal Detection')
@Controller('metal-detection')
export class MetalDetectionController {
    constructor(private service: MetalDetectionService, private readonly applicationExceptionHandler: ApplicationExceptionHandler) { }

    @Post('/createMetalDetectionLog')
    async createMetalDetectionLog(@Body() data: MetalDetectionDto): Promise<CommonResponse> {
        try {
            return await this.service.createMetalDetectionLog(data);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error)
        }
    }

    @Post('/getMetalDetectionLog')
    async getMetalDetectionLog(@Body() date: DateFilter): Promise<CommonResponse> {
        try {
            return await this.service.getMetalDetectionLog(date);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error)
        }
    }
}
